import { render, staticRenderFns } from "./RecoverPasswordModal.vue?vue&type=template&id=fb50d4f8&scoped=true"
import script from "./RecoverPasswordModal.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./RecoverPasswordModal.vue?vue&type=style&index=0&id=fb50d4f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb50d4f8",
  null
  
)

export default component.exports